// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import CollabNavigation from './CollabNavigation'
import { Button } from 'ui'
import { Alert } from 'ui'
import LoadingButton from '../LoadingButton'
import Disclaimer from '../Disclaimer'
import { getSubscriptionAmount, getSubscriptionInterval } from '../../../utils/subscriptionUtils';

function CollabModalActivate({ 
  email, 
  subscription, 
  onAddSeat, 
  onSkip, 
  addingSeat 
}) {
  const amount = getSubscriptionAmount(subscription);
  const interval = getSubscriptionInterval(subscription);

  return (
    <CollabNavigation
      title='Invitation Sent'
    >
      <Alert variant="warning">
        <div>
          <strong>
            {email} can only view this project,
            because they don't have an active subscription.
          </strong>
        </div>
      </Alert>

      <div style={{
        marginTop: '20px',
        marginLeft: '10px',
        marginRight: '10px',
        marginBottom: '40px',
        textAlign: 'center',
        fontSize: '1em'
      }}>
        Add {email} to your subscription for an
        additional ${amount} per {interval} to enable them to edit your project.
      </div>

      <div>
        <LoadingButton
          variant="blue"
          width={300}
          loading={addingSeat}
          onClick={() => onAddSeat(email)}
          centered
        >
          Add to your subscription
        </LoadingButton>
      </div>
      <div style={{textAlign: 'center', marginTop:'5px'}}>
        <Button
          variant="link"
          onClick={onSkip}
          disabled={!!addingSeat}
        >
          Continue without adding
        </Button>
      </div>
      <div style={{textAlign: 'center', fontSize: '.8em'}}>
        <Disclaimer>
          By adding an additional team member, you agree to be charged a prorated amount for this month starting on your next billing cycle, and to automatically be charged each month with your updated number of team members until you cancel.
        </Disclaimer>
      </div>
    </CollabNavigation>
  );
}

export default CollabModalActivate;
